import React from "react";
import { logout } from "../../redux/slices/mainDataSlice";
import { useDispatch } from "react-redux";

export default function Header({ text, isHome = false, isAll = false }) {
  // Generate the next 10 versions dynamically based on the given version number
  const dispatch = useDispatch();
  return (
    <div className={`head ${isAll ? "all" : ""}`}>
      {isHome ? (
        <>
          {" "}
          <img src="/images/logo.svg" alt="" className="logo" />
        </>
      ) : (
        <></>
      )}
      <div className="logoText">{text}</div>
      <div className="back-effect"></div>
      <div className="setting" onClick={() => dispatch(logout())}>
        <i class="fas fa-sign-out-alt"></i>{" "}
      </div>
      {/* {showSettingBox && (
        <div className="setting-box">
          <div
            className="layout"
            data-aos="fade-in"
            onClick={() => {
              setShowSettingBox(false);
            }}
          ></div>
          <div className="box" data-aos="fade-in">
            <div className="title">نشر اصدار جديد</div>
            <div className="version-box">
              <div className="group">
                <div className="text">رقم الاصدار</div>
                <input
                  type="text"
                  name="text"
                  value={versionNumber}
                  onChange={(e) => setVersionNumber(e.target.value)}
                />
              </div>
              <div className="group">
                <div className="text">تاريخ الاصدار</div>
                <input
                  type="date"
                  name="releaseDate"
                  value={releaseDate}
                  onChange={(e) => setReleaseDate(e.target.value)}
                />
              </div>
              <div className="group spic">
                <div className="text">رساله المستخدم</div>

                <textarea
                  name=""
                  id=""
                  value={dayNote}
                  onChange={(e) => setDayNote(e.target.value)}
                ></textarea>
              </div>
              <div className="group">
                <div className="text">تاريخ لنهاية العام الدراسي</div>
                <input
                  type="date"
                  name="releaseDate"
                  value={releaseDate2}
                  onChange={(e) => setReleaseDate2(e.target.value)}
                />
              </div>
              <div className="publish-version" onClick={handlePublishVersion}>
                تحديث البيانات
              </div>
            </div>
            <div className="logout-btn" onClick={() => dispatch(logout())}>
              <div className="text">تسجيل خروج</div>
              <i className="fa-solid fa-door-open"></i>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}
